import React from 'react'

import Modal from 'react-bootstrap/lib/Modal.js'
import * as css from '../FondosAsignados.css'
import classNames from 'classnames/bind'

let cx = classNames.bind(css)
let PropTypes = React.PropTypes

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = {visible: false}
        let self = this
        this.show = ()=>
            self.setState({visible: true})
        this.hide = ()=>{
            self.setState({visible: false})
        }
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalGasto extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            gasto: {},
            nuevo: 1,
            fotoGasto: '',
            tipoDocumentos: [{idTipoDocumento: 1, nombre:'Factura'}, {idTipoDocumento: 2, nombre:'Boleta'}],
            tipoGastos: [{idTipoGasto: 1, nombre: 'Traslado'}, {idTipoGasto: 2, nombre: 'Acercamientos'}],
            error: []
        }
        this.onInputChange =(key, evt)=>{
            let actualizado = {}
            actualizado[key] = evt.target.value
            actualizado.idEstado = 1
            this.setState({ gasto: Object.assign({}, this.state.gasto, actualizado)})
        }
        this.onComprobanteChange=(evt)=>{
            if(evt.target.files[0]){
                let fotoGasto = {}
                let gasto = this.state.gasto
                fotoGasto = evt.target.files[0]
                this.context.subirFotoGasto(fotoGasto)
                    .then(resp=>{
                        console.log(resp)
                        gasto.idFotoDocumento = resp
                        this.setState({
                            fotoGasto,
                            gasto
                        })
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        }
        this.guardarGasto =()=>{
            if(this.state.nuevo){
                this.context.nuevoGasto(this.state.gasto)
                    .then(resp=>{
                        this.props.hideModal()
                    })
                    .catch(err=>{
                        console.log(err)
                       this.setState({
                           error: err.data
                       })
                    })
            }else{
                this.context.modificarGasto(this.state.gasto)
                    .then(resp=>{
                        console.log(resp)
                        this.props.hideModal()
                    })
                    .catch(err=>{
                        console.log(err)
                        this.setState({
                            error: err.data
                        })
                    })
            }
        }
        this.getTipoDocumentos=()=>{
            this.context.getTipoDocumentos()
                .then(tipoDocumentos=>{
                    this.setState({tipoDocumentos})
                })
                .catch(err=>{
                    console.log(err)
                })
        }
        this.getTipoGastos=()=>{
            this.context.getTipoGastos()
                .then(tipoGastos=>{
                    this.setState({tipoGastos})
                })
                .catch(err=>{
                    console.log(err)
                })
        }
    }
    componentWillMount(){
        this.getTipoDocumentos()
        this.getTipoGastos()
        if(this.props.idGastoRendicion){
            this.context.getGasto(this.props.idGastoRendicion)
                .then(gasto=>{
                    this.setState({
                        gasto,
                        nuevo: 0
                    })
                })
                .catch(err=>{
                    console.log(err)
                })
        }
    }
    componentDidMount(){
        this.inputFecha.focus()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalGasto')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.nuevo? "Creando un nuevo gasto a la rendición" : "Editando gasto de la rendición"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 col-xs-12">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-md-4 col-xs-12 form-group">
                                        <label>Fecha </label>
                                        <input type="date" className="form-control"
                                            ref={(fecha) => { this.inputFecha = fecha }}
                                            value={this.state.gasto.fechaEmision}
                                            onFocus={()=>{ this.inputFecha.select() }}
                                            onChange={this.onInputChange.bind(this, 'fechaEmision')}
                                        />
                                        {this.state.error.fechaEmision && <span className={cx('form__error-message')}>{this.state.error.fechaEmision}</span>}
                                    </div>
                                    <div className="col-md-4 col-xs-12 form-group">
                                        <label>Tipo Documento</label>
                                        <select className={"form-control"}
                                                value={this.state.gasto.idTipoDocumento}
                                                onChange={this.onInputChange.bind(this, 'idTipoDocumento')}>
                                            <option value="0">Tipo Documento</option>
                                            {this.state.tipoDocumentos.map((tipoDocumento, index)=>{
                                                return <option key={index} value={tipoDocumento.idTipoDocumento}>{tipoDocumento.nombre}</option>
                                            })}
                                        </select>
                                        {this.state.error.idTipoDocumento && <span className={cx('form__error-message')}>{this.state.error.idTipoDocumento}</span>}
                                    </div>
                                    <div className="col-md-4 col-xs-12 form-group">
                                        <label>Tipo Gasto</label>
                                        <select className={"form-control"}
                                                value={this.state.gasto.idTipoGasto}
                                                onChange={this.onInputChange.bind(this, 'idTipoGasto')}>
                                            <option value="0">Tipo Gasto</option>
                                            {this.state.tipoGastos.map((tipoGasto, index)=>{
                                                return <option key={index} value={tipoGasto.idTipoGasto}>{tipoGasto.nombre}</option>
                                            })}
                                        </select>
                                        {this.state.error.idTipoGasto && <span className={cx('form__error-message')}>{this.state.error.idTipoGasto}</span>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 col-xs-12 form-group">
                                        <label>Número Comprobante </label>
                                        <input type="text" className="form-control"
                                            ref={(numero_documento) => { this.inputNumero_Documento = numero_documento }}
                                            value={this.state.gasto.numero_documento}
                                            onFocus={()=>{ this.inputNumero_Documento.select() }}
                                            onChange={this.onInputChange.bind(this, 'numero_documento')}
                                        />
                                        {this.state.error.numero_documento && <span className={cx('form__error-message')}>{this.state.error.numero_documento}</span>}
                                    </div>
                                    <div className="col-md-4 col-xs-12 form-group">
                                        <label>Total </label>
                                        <input type="number" className="form-control"
                                            ref={(total) => { this.inputTotal = total }}
                                            value={this.state.gasto.total}
                                            onFocus={()=>{ this.inputTotal.select() }}
                                            onChange={this.onInputChange.bind(this, 'total')}
                                        />
                                        {this.state.error.total && <span className={cx('form__error-message')}>{this.state.error.total}</span>}
                                    </div>
                                    <div className="col-md-4 col-xs-12 form-group">
                                        <label>Subir Foto</label>
                                        <div>
                                            <label htmlFor="subirFoto">
                                                <i className={this.state.gasto.idFotoDocumento? "btn btn-xs btn-primary" : "btn btn-xs btn-success  "}
                                                    title="Seleccionar Foto"><span className="glyphicon glyphicon-open-file"/> {this.state.gasto.idFotoDocumento? "Reemplazar Foto" : "Seleccione Archivo"}</i>
                                                <input id="subirFoto" type="file"
                                                    onChange={this.onComprobanteChange}/>
                                            </label>
                                        </div>
                                        {this.state.error.foto_documento && <span className={cx('form__error-message')}>{this.state.error.foto_documento}</span>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 col-xs-12 form-group">
                                        <label>Glosa </label>
                                        <textarea className="form-control" rows="2"
                                            ref={(glosa) => { this.inputGlosa = glosa }}
                                            value={this.state.gasto.glosa}
                                            onFocus={()=>{ this.inputGlosa.select() }}
                                            onChange={this.onInputChange.bind(this, 'glosa')}/>
                                        {this.state.error.glosa && <span className={cx('form__error-message')}>{this.state.error.glosa}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-6">
                        <button className="btn btn-md btn-primary pull-left"
                            onClick={this.guardarGasto}>
                            <span className="glyphicon glyphicon-ok"/> Guardar
                        </button>
                    </div>   
                    <div className="col-md-6">
                        <button className="btn btn-md btn-cancel" onClick={this.props.hideModal}><span className="glyphicon glyphicon-remove"/> Cancelar</button>
                    </div>                        
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalGasto.contextTypes = {
    nuevoGasto: PropTypes.func,
    getGasto: PropTypes.func,
    modificarGasto: PropTypes.func,
    subirFotoGasto: PropTypes.func,
    getTipoDocumentos: PropTypes.func,
    getTipoGastos: PropTypes.func
}
export class VerFotoGasto extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalGasto')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Foto Gasto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 col-xs-12">
                            <img src={`${this.props.ruta_imagen}`} className={cx('imagenOriginal')}/>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-6">
                        <button className="btn btn-md btn-primary pull-left"
                                onClick={this.guardarGasto}>
                            <span className="glyphicon glyphicon-ok"/> Guardar
                        </button>
                    </div>
                    <div className="col-md-6">
                        <button className="btn btn-md btn-cancel" onClick={this.props.hideModal}><span className="glyphicon glyphicon-remove"/> Cancelar</button>
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }   
}
export class ModalInformarGastos extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalGasto')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Informar mís gastos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>ATENCIÓN, informará la rendición a los administradores, si realiza esta acción no podrá volver a modificar su rendición mientras está siendo revisada, ¿Desea proceder?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-6">
                        <button className="btn btn-md btn-warning pull-left"
                                onClick={this.guardarGasto}>
                            <span className="glyphicon glyphicon-envelope"/> Informar
                        </button>
                    </div>
                    <div className="col-md-6">
                        <button className="btn btn-md btn-cancel" onClick={this.props.hideModal}><span className="glyphicon glyphicon-remove"/> Cancelar</button>
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/detalle-fondo/Modales.jsx